/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../../types/QueryTags'
import { ValidateSwiftResponse } from '../transfers/types/response'

import { 
  FetchBeneficiariesResponse, 
  AddBeneficiaryRequest, 
  AddBeneficiaryResponse, 
  DeleteBeneficiaryRequest, 
  DeleteBeneficiaryResponse, 
  UpdateBeneficiaryRequest, 
  UpdateBeneficiaryResponse, 
  GetBillerFieldsResponse, 
  checkBeneficiaryNameRequest,
  FetchTransactionTypeResponse, 
  FetchBeneficiariesRequest,
  EditBeneficiaryRequest,
  ValidateBeneficiaryResponse,
  BeneficiaryPendingApprovalRequest,
  BeneficiaryPendingApprovalResponse
} from './types'


import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'


const basePath = 'beneficiary-service'
const billersBasePath = 'biller-service'

const beneficiariesEndpoints = (builder: EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) => 
  ({
    getBeneficiaries: builder.query<FetchBeneficiariesResponse, FetchBeneficiariesRequest> ({
      query: () => `${basePath}/beneficiary`,
      providesTags:['beneficiaries'] 
    }),
    addBeneficiary: builder.mutation<AddBeneficiaryResponse, AddBeneficiaryRequest>({
      query: (body) => {
        return ({
          url:`${basePath}/beneficiary`,
          method: 'POST',
          body,
        })
      },
      invalidatesTags:['beneficiaries']
    }),
    deleteBeneficiary: builder.mutation<DeleteBeneficiaryResponse, DeleteBeneficiaryRequest>({
      query: (body) => {
        return ({
          url:`${basePath}/beneficiary`,
          method: 'DELETE',
          body,
        })
      },
      invalidatesTags:['beneficiaries']
    }),
    updateBeneficiaries: builder.mutation<UpdateBeneficiaryResponse, UpdateBeneficiaryRequest>({
      query: ({id,body}) => {
        return ({
          url:`${basePath}/beneficiary`,
          method: 'PATCH',
          params: {id},
          body,
        })
      },
      invalidatesTags:['beneficiaries']
    }),
    getBillersFields: builder.query<GetBillerFieldsResponse, string>({
      query: (billerId) => `${billersBasePath}/view-biller/${billerId}/field`,
    }),

    //beneficiary v-2

    checkBeneficiaryName: builder.mutation<string, checkBeneficiaryNameRequest>({
      query: (body) => ({
        url: `${basePath}/beneficiary/check`,
        method: 'POST',
        body
      })
    }), 
    fetchTransactionType: builder.query<FetchTransactionTypeResponse,string>({
      query: () => `${basePath}/beneficiary/fields`
    }),
    updateBeneficiary: builder.mutation<AddBeneficiaryResponse, EditBeneficiaryRequest>({
      query: ({body, id}) => ({
        url: `${basePath}/beneficiary?id=${id}`,
        method: 'PATCH',
        body: body
      }),
      invalidatesTags:['beneficiaries']
    }),
    validateBeneficiaryAccount: builder.query<ValidateBeneficiaryResponse, any>({
      query: (payload) => `${payload}`
    }),
    validateBeneficiaryBillpaymentAccount: builder.mutation<any, any>({
      query: ({url, payload}) => ({
        url: `${url}`,
        method: 'POST',
        body: payload
      })
    }),
    validateSwiftBeneficiaryCode: builder.mutation<ValidateSwiftResponse, any>({
      query: (url) => ({
        url: `${url}`,
        method: 'POST'
      })
    }),
    getBeneficaryPendingApproval: builder.query<BeneficiaryPendingApprovalResponse, { page?: number, limit?: number, }>({
      query: ({ page, limit}) => {
        return ({
          url: `${basePath}/beneficiary/pending-approval`,
          method: 'GET',
          params: { page, limit }
        })
      },
    }),
    approveBeneficiary: builder.mutation<any, { id: string, status: string, }>({
      query: ({ id, status}) => ({
        url: `${basePath}/beneficiary/beneficiary-approval/${id}`,
        method: 'POST',
        params: { status }
      }),
      invalidatesTags:['beneficiaries']
    }),
    importBeneficiaries: builder.query<any, string>({
      query: (customerNumber) => ({
        url: `administration/api/migrated-customers/import-beneficiary?customerNumber=${customerNumber}`,
        method: 'GET',
      }),
    }),
  })
  
export default beneficiariesEndpoints